import React from 'react';
import { Tag } from '@innovationnorway/component-library';
import { OneWayInServiceDto } from 'src/api/v2';
import './ServiceInfo.scss';
import i18next from 'i18next';
import { sanitizeD365RichTextEditor } from 'src/features/one-way-in/utils/htmlTextConverter';

const ServiceInfo = ({ row }: { row: { original: OneWayInServiceDto } }) => {
  const { t } = i18next;

  return (
    <div className="service-info">
      <div
        className="service-info__description"
        dangerouslySetInnerHTML={{ __html: sanitizeD365RichTextEditor(row.original.description || '') }}
      />
      <div className="service-info__details">
        <div className="service-info__details--type">
          <p>
            <p className="font-weight--bold">Type</p>
            <p>
              {row.original.deliveryTypes.map((type, index) => (
                <Tag className="margin-right--1" key={index} type="info">
                  {type}
                </Tag>
              ))}
            </p>
          </p>
        </div>
        <div className="service-info__details--requirements">
          <p>
            <p className="font-weight--bold">{t<string>('oneWayIn:referring.requirements')}</p>
          </p>
          <p>
            {t<string>('oneWayIn:referring.companyAge')}: {row.original.companyAge}
          </p>
          <p>
            {t<string>('accountProfile:companySize')}:{' '}
            {row.original.companySize?.map((size, index) => (
              <Tag className="margin-right--1" key={index} type="info">
                {size}
              </Tag>
            ))}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceInfo;
